import React from 'react';
import { Link } from 'react-router-dom';

// items: [{ name, path }] excluding Home; last item is the current page.
const Breadcrumbs = ({ items }) => (
  <nav className="breadcrumbs" aria-label="Breadcrumb">
    <div className="container">
      <ol>
        <li><Link to="/">Home</Link></li>
        {items.map((item, i) => (
          <li key={item.path}>
            {i === items.length - 1
              ? <span aria-current="page">{item.name}</span>
              : <Link to={item.path}>{item.name}</Link>}
          </li>
        ))}
      </ol>
    </div>
  </nav>
);

export default Breadcrumbs;
